import classNames from "classnames";
import { createUseStyles } from "react-jss";
import Input from "../Input";

interface Props {
  className?: string;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  description?: string;
  onChange: (name: any, value: any) => void;
  required?: boolean;
  inputFormat?: string;
  value?: string;
  name?: string;
}

const useStyles = createUseStyles({
  root: {},
});

const DateInput = ({
  className,
  label,
  placeholder,
  errorMessage,
  description,
  onChange,
  required = false,
  value,
  name,
}: Props) => {
  const classes = useStyles();

  return (
    <Input
      label={label}
      placeholder={placeholder}
      errorMessage={errorMessage}
      description={description}
      required={required}
      className={classNames(classes.root, className)}
      onChange={onChange}
      type="date"
      name={name}
    />
  );
};

export default DateInput;
